module.exports = __webpack_public_path__ + "static/media/puinspect-w-icon-white.db813bbc.svg";